import React, { Fragment, useState } from "react";
import { Container, ListGroup, ListGroupItem, Form, FormFeedback, Button, FormGroup, Label, Input } from "reactstrap";

import classnames from 'classnames';

import ValidationGroup from "~/components/validation";
import Msg             from "~/components/messages";
import Contact         from "~/services/contact";

const SupportPage = ()=> {

  const [loading , setLoading] = useState(false);
  const [errors  , setErrors]  = useState({});
  const [mail    , setMail]    = useState({
    subject : '',
    offer   : '',
    message : '',
  });

  const validation = ValidationGroup("Contact");

  const hasErrors = ()=> {

    const errorList = {
      ...validation("subject", mail.subject),
      ...validation("offer",   mail.offer),
      ...validation("message", mail.message),
    };
    setErrors(errorList);

    return Boolean(Object.keys(errorList).length);
  };

  const changeProp = (key, val)=> ( setMail((prev)=> ( { ...prev, [key]: val } )));

  const submitForm = async (e)=> {

    e.preventDefault();
    if(hasErrors()) return;
    setLoading(true);

    await Contact.sendMessage(mail)
      .then((message)=> { Msg.contactUs(message); setLoading(false)})
      .catch(setErrors)
      .finally(()=> setLoading(false));
  };

  return (
    <Fragment>
      <Container fluid={true} className="contact-page">

        <h4 className='contact-us'>Support</h4>

        <Form className="theme-form" onSubmit={submitForm}>

          <FormGroup>
            <Label>Subject</Label>
            <Input type="text"
              onChange={(e)=> changeProp("subject", e.target.value)}
              className={classnames({'is-invalid': errors.subject}) }
              placeholder="Subject"
            />
            {errors.subject && <FormFeedback> {errors.subject} </FormFeedback> }
          </FormGroup>

          <FormGroup>
            <Label>Offer Name</Label>
            <Input type="text"
              onChange={(e)=> changeProp("offer", e.target.value)}
              className={classnames({'is-invalid': errors.offer })}
              placeholder="Offer Name"
            />
            {errors.offer && <FormFeedback> {errors.offer} </FormFeedback> }
          </FormGroup>

          <FormGroup>
            <Label>Message</Label>
            <Input type="textarea"
              onChange={(e)=> changeProp("message", e.target.value)}
              className={classnames({'is-invalid': errors.message })}
              placeholder="Message"
            />
            {errors.message && <FormFeedback> {errors.message} </FormFeedback> }
          </FormGroup>

          <Button disabled={loading} color="primary" className="btn-block m-t-40" type="submit"> Submit </Button>
        </Form>

        <h5 className='text-center m-b-40 m-t-50'> Find us on</h5>

        <ListGroup horizontal>
          <ListGroupItem>
            <button>
              <a href="https://www.facebook.com/earndorado" target="_blank"><i className="fa fa-facebook"></i></a>
            </button>
          </ListGroupItem>

          <ListGroupItem>
            <button>
              <a href="https://www.instagram.com/earndorado" target="_blank"><i className="fa fa-instagram" ></i></a>
            </button>
          </ListGroupItem>

          <ListGroupItem>
            <button>
              <a href="https://telegram.me/earndorado" target="_blank"><i className="fa fa-telegram" ></i></a>
            </button>
          </ListGroupItem>
        </ListGroup>
      </Container>
    </Fragment>
  );
}

export default SupportPage;
